






import { Component, Vue } from 'vue-property-decorator'
import { DataServicesState } from '../store'

@Component({
  components: {
  }
})
export default class DataservicesPage extends Vue {
  public mounted () {

  }

  public created () {
  }

  public activated () {
  }

  public updated () {
  }

  public destroyed () {
  }

  public deactivated () {

  }
}
